import { cn } from '~/shadcn/lib/utils'

type Props = {
  label: string
  onClick: () => void
  isActive: boolean
  colorScheme?: 'light' | 'dark'
  count?: {
    value: number
    bgColor: string
    color: string
  }
}

const underlineStyles = [
  'after:content-[""] after:absolute after:bottom-0 after:left-0',
  'after:w-full after:h-0.5 after:z-[1]',
  'after:bg-accent after:origin-center',
  'after:transition-all after:duration-300',
]

function ProjectsTab({
  label,
  onClick,
  isActive,
  count,
  colorScheme = 'dark',
}: Props) {
  const isDark = colorScheme === 'dark'

  return (
    <button
      className={cn(
        'cursor-pointer gap-2 relative',
        'flex flex-row items-center justify-start rounded-none',
        'text-xl md:text-2xl font-semibold text-nowrap',
        'pt-10 md:pt-3 pr-8 md:pr-15 pb-6 md:pb-7 pl-2 md:pl-3',
        'border-transparent',
        underlineStyles,
        isActive
          ? cn(
              'outline-blue-600',
              isDark ? 'text-primary-foreground' : 'text-primary',
              'after:opacity-100 after:scale-x-100'
            )
          : cn(
              'outline-transparent text-muted-foreground',
              'after:opacity-0 after:scale-x-0',
              'hover:after:opacity-100 hover:after:scale-x-100'
            )
      )}
      onClick={onClick}>
      <span>{label}</span>
      {count != null && (
        <div
          className="flex h-5 items-center justify-center rounded-full px-1.5 text-sm"
          style={{
            backgroundColor: count.bgColor,
            color: count.color,
          }}>
          {count.value}
        </div>
      )}
    </button>
  )
}

function ProjectsTabsContainer({ children }: { children: React.ReactNode }) {
  return <div className="border-b border-border-strong">{children}</div>
}

export { ProjectsTab, ProjectsTabsContainer }
